// extracted by mini-css-extract-plugin
export var blok_content = "index-module--blok_content--8f268";
export var card_header_caption = "index-module--card_header_caption--39df4";
export var card_header_container = "index-module--card_header_container--b9617";
export var card_header_name_tag = "index-module--card_header_name_tag--412f9";
export var card_header_tag = "index-module--card_header_tag--69498";
export var feature_desc_caption = "index-module--feature_desc_caption--81553";
export var feature_item = "index-module--feature_item--4e362";
export var feature_item_caption = "index-module--feature_item_caption--04567";
export var features_container = "index-module--features_container--7c78b";
export var features_list_container = "index-module--features_list_container--5e756";
export var free_upgrade_btn = "index-module--free_upgrade_btn--42d80";
export var home_page_pricing_feature_item_desc = "index-module--home_page_pricing_feature_item_desc--d04a6";
export var price_btn_container = "index-module--price_btn_container--bc3d4";
export var price_desc_container = "index-module--price_desc_container--ff036";
export var price_desc_month_container = "index-module--price_desc_month_container--91a6b";
export var price_desc_tag_container = "index-module--price_desc_tag_container--6ee76";
export var price_unit_container = "index-module--price_unit_container--db18b";
export var pricing_account_tag_container = "index-module--pricing_account_tag_container--624b4";
export var pricing_container = "index-module--pricing_container--4060d";
export var pricing_desc_caption = "index-module--pricing_desc_caption--67960";
export var pricing_page_btn = "index-module--pricing_page_btn--e5ae2";
export var pro_features_container = "index-module--pro_features_container--15836";
export var pro_price_container = "index-module--pro_price_container--083a1";
export var pro_upgrade_btn = "index-module--pro_upgrade_btn--e013c";
export var upgrade_btn_container = "index-module--upgrade_btn_container--3faf7";
export var useless_btn = "index-module--useless_btn--0e23d";